<div [ngClass]="{'paddin-empty':!system.attributes.can_receive ||
    (system.relationships.system_information.data &&
    system.relationships.system_information.data[0] &&
    system.relationships.system_information.data[0].attributes &&
    system.relationships.system_information.data[0].attributes.time_average &&
    system.relationships.system_information.data[0].attributes.time_average === 0)
}">
    <h3 class="title-resume-system">Comprar o vender {{ displayTitle }} {{ countryName ? ' en ' + countryName : '' }}</h3>
    <p class="secondary-text">Visualiza los tiempos de pago y el valor actual del mercado. ¡Opera ahora!</p>
    <app-empty-component *ngIf="(!system.attributes.can_receive || system.relationships.system_information.data[0].attributes.time_average === 0) && system.id !== 'banco_bol'"></app-empty-component>
    <mat-card class="rs-wrapper-v4"
              *ngIf="(system.id !== 'banco_bol' && system.attributes.can_receive && system.relationships.system_information.data[0].attributes.time_average !== 0) || system.id === 'banco_bol'">
        <app-comparison-table-system [systemsKey]="systemsKey" [system]="system" [defaultSystems]="defaultSystems"></app-comparison-table-system>
    </mat-card>
</div>
